import React from "react";

const PageEmptyData = ({ message = "" }) => {
  return (
    <div className="page-content">
      <div className=" text-center p-4">
        {message ? <p>{message}</p> : <p>No se encontro información</p>}
      </div>
    </div>
  );
};

export default PageEmptyData;
